import {useEffect, useRef} from "react";

import {RootDesc} from "@ui/descriptions/RootDesc";
import {RatingRange} from "@ui/inputs/RatingRange";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const RootRadio = (props) => {
  const {isMobile} = useSelector((state) => state.common.settings);
  const {
    checked,
    onChange,
    label,
    disabled,
    tabIndex,
    name,
    value,
    id,
    className,
    isOther,
    onOtherChange,
    otherValue,
    input,
  } = props;

  const inputRef = useRef(null);

  useEffect(() => {
    if (checked && isOther && inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 0);
    }
  }, [checked, isOther]);

  const handleInputFocus = () => {
    if (isOther && !checked && onChange) {
      onChange();
    }
  };

  if (input) {
    return (
      <div className={styles.otherInput}>
        <input
          ref={inputRef}
          placeholder={label}
          className={styles.editInput}
          type={"text"}
          value={otherValue || ""}
          onChange={(e) => onOtherChange(e.target.value)}
          onFocus={handleInputFocus}
          aria-label={label}
          style={{
            width: "100%",
            maxWidth: "100%",
            borderBottom: "1rem solid var(--grey)",
            transition: "all 0.15s linear",
            padding: "4rem 8rem",
          }}
        />
      </div>
    );
  }

  return (
    <label
      className={`${styles.rootRadio} ${className || ""}`}
      style={{pointerEvents: `${disabled ? "none" : "all"}`}}
      tabIndex={tabIndex ? tabIndex : undefined}
      role={"radio"}
      aria-checked={checked}
      htmlFor={id}
    >
      <input
        id={id}
        name={name}
        value={value}
        type={"radio"}
        checked={disabled ? false : checked}
        onChange={disabled ? undefined : onChange}
        aria-label={label}
        disabled={disabled}
      />

      <i className={styles.mark} />

      {label && !isOther && (
        <RootDesc>
          {typeof label !== "string" ? (
            <b>{label}</b>
          ) : (
            <b dangerouslySetInnerHTML={{__html: label}} />
          )}
        </RootDesc>
      )}

      {isOther && (
        <div className={styles.otherInput}>
          <input
            ref={inputRef}
            placeholder={label}
            className={styles.editInput}
            type={"text"}
            value={otherValue || ""}
            onChange={(e) => onOtherChange(e.target.value)}
            onFocus={handleInputFocus}
            aria-label={label}
            style={{
              width: !isMobile ? "250rem" : "100%",
              maxWidth: "100%",
              borderBottom: "1rem solid var(--grey)",
              transition: "all 0.15s linear",
              padding: "4rem 8rem",
            }}
          />
        </div>
      )}
    </label>
  );
};

export const RadioGroup = (props) => {
  const {isMobile} = useSelector((state) => state.common.settings);
  const {
    rating = false,
    ratingType = "stars",
    minLabel,
    maxLabel,
    input = false,
    required,
    title,
    name,
    options,
    value,
    onChange,
    disabled,
    className,
    layout = "vertical",
    otherValue,
    onOtherChange,
  } = props;

  return (
    <div
      style={{
        width: `${input ? "100%" : !isMobile ? "fit-content" : "100%"}`,
      }}
      className={`${styles.radioGroup} ${styles[layout]} ${className || ""}`}
    >
      {title && (
        <h4>
          {required && <b>*</b>} {title}
        </h4>
      )}

      {options &&
        options.map((option) => (
          <RootRadio
            key={option.id || option.value}
            id={`${name}-${option.id || option.value}`}
            name={name}
            value={option.value}
            label={option.label}
            checked={value === option.value}
            onChange={() => onChange(option)}
            disabled={disabled || option.disabled}
            isOther={option.value === "other"}
            onOtherChange={onOtherChange}
            otherValue={otherValue}
            input={input}
          />
        ))}

      {rating && (
        <RatingRange
          disabled={disabled}
          ratingType={ratingType}
          minLabel={minLabel}
          maxLabel={maxLabel}
          value={value}
          onChange={onChange}
        />
      )}
    </div>
  );
};
